import React from 'react';

const dd = (props) => {
  const {
    data = [],
    label,
    value,
    id = null,
    boxClass = '',
    labelClass = '',
    formClass = 'form-group form-row',
    invalidFeedback = null,
    onChange,
    areAddressDetailsValid = true,
    disabled = false
  } = props;

  const renderOpt = ({
    disabled = false,
    label: optLabel,
    value: optValue,
  }) => <option key={optValue} value={optValue} disabled={disabled}>{optLabel}</option>;

  return (
    <div className={formClass}>
      <label className={`${labelClass}`}
      htmlFor={id}>{label}</label>
      <div className={boxClass}>
        <select
          value={value}
          onChange={onChange}
          className='custom-select py-0 w-100'
          style={{ 'borderColor': areAddressDetailsValid ? null : 'red' }}
          id={id}
          disabled={disabled}>
        {data.map(renderOpt)}
        </select>
        { invalidFeedback &&
          <div className="invalid-feedback">
            {invalidFeedback}
          </div>
        }
      </div>

    </div>
  );
};

export default dd;



// WEBPACK FOOTER //
// ./src/Common/SimpleDropdown.js